import { render } from "./BaseCode.vue?vue&type=template&id=0c652130&scoped=true"
import script from "./BaseCode.vue?vue&type=script&lang=js"
export * from "./BaseCode.vue?vue&type=script&lang=js"

import "./BaseCode.vue?vue&type=style&index=0&id=0c652130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c652130"]])

export default __exports__